import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../contexts/LanguageContext';

const LanguageSwitcher = ({ className = '' }) => {
  const { language, toggleLanguage } = useLanguage();

  return (
    <motion.button
      onClick={toggleLanguage}
      className={`flex items-center gap-2 px-3 py-1.5 bg-white/10 hover:bg-white/20 rounded-full border border-white/20 transition-all duration-300 ${className}`}
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      title={language === 'th' ? 'Switch to English' : 'เปลี่ยนเป็นภาษาไทย'}
    >
      <motion.div
        className="relative flex items-center"
        initial={false}
        animate={{ x: language === 'th' ? 0 : 0 }}
      >
        {/* Flag Icons */}
        <div className="flex items-center gap-1.5">
          <motion.span
            className={`text-sm transition-opacity ${language === 'th' ? 'opacity-100' : 'opacity-40'}`}
            animate={{ scale: language === 'th' ? 1.1 : 1 }}
          >
            🇹🇭
          </motion.span>
          <span className="text-white/50 text-xs">/</span>
          <motion.span
            className={`text-sm transition-opacity ${language === 'en' ? 'opacity-100' : 'opacity-40'}`}
            animate={{ scale: language === 'en' ? 1.1 : 1 }}
          >
            🇬🇧
          </motion.span>
        </div>
      </motion.div>
      
      <span className="text-xs font-medium text-white uppercase tracking-wide">
        {language}
      </span>
    </motion.button>
  );
};

// Compact version for navbar
export const LanguageSwitcherCompact = ({ className = '' }) => {
  const { language, toggleLanguage } = useLanguage();

  return (
    <motion.button
      onClick={toggleLanguage}
      className={`flex items-center justify-center w-9 h-9 bg-gray-100 hover:bg-gray-200 rounded-full transition-all duration-300 ${className}`}
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      title={language === 'th' ? 'Switch to English' : 'เปลี่ยนเป็นภาษาไทย'}
    >
      <span className="text-lg">
        {language === 'th' ? '🇹🇭' : '🇬🇧'}
      </span>
    </motion.button>
  );
};

// Toggle style switcher
export const LanguageToggle = ({ className = '' }) => {
  const { language, setLanguage } = useLanguage();

  return (
    <div className={`flex items-center bg-gray-100 rounded-full p-1 ${className}`}>
      <button
        onClick={() => setLanguage('th')}
        className={`flex items-center gap-1 px-3 py-1 rounded-full text-sm font-medium transition-all ${
          language === 'th'
            ? 'bg-blue-500 text-white shadow-md'
            : 'text-gray-600 hover:text-gray-900'
        }`}
      >
        🇹🇭 ไทย
      </button>
      <button
        onClick={() => setLanguage('en')}
        className={`flex items-center gap-1 px-3 py-1 rounded-full text-sm font-medium transition-all ${
          language === 'en'
            ? 'bg-blue-500 text-white shadow-md'
            : 'text-gray-600 hover:text-gray-900'
        }`}
      >
        🇬🇧 EN
      </button>
    </div>
  );
};

export default LanguageSwitcher;
